import assign from 'lodash/assign';
import noop from 'lodash/noop';
import Logger from 'observability/Logger';

const LOG = new Logger('PostMessage');

const DEFAULT_OPTIONS = {
    target: window.parent,
    origin: '*',
    callback: noop,
    verify: noop,
};

export default class PostMessage {
    constructor(options = {}) {
        this.options = assign({}, DEFAULT_OPTIONS, options);
        this.target = this.options.target;
        this.origin = this.options.origin;
        this.callback = this.options.callback;
        this.verify = this.options.verify;
    }

    listen() {
        LOG.info('[PostMessage][listening]');
        window.addEventListener(
            'message',
            (e) => {
                const key = e.message ? 'message' : 'data';
                const data = e[key];
                // Chrome -- origin property is in event.originalEvent object.
                const origin = e.origin || e.originalEvent.origin;
                const logMessage = data?.payload?.event || data?.source || data?.event || '';
                LOG.info(`[PostMessage][received] ${logMessage}`, { origin, data });
                if (this.verify(origin)) {
                    this.callback(data);
                }
            },
            false,
        );
    }

    send(msg) {
        const event = msg.event ? ` Event: ${msg.event}` : '';
        LOG.info(`[PostMessage][sent]${event}`, { msg });
        this.target.postMessage(msg, this.origin);
    }

    static start(...args) {
        return new this(...args);
    }
}
